import React from 'react';
import { Link } from 'react-router-dom';
import CollapseHeader from '../../../core/common/collapse-header/collapse-header';

const GroupPersonalAccident = () => {
    return (
        <div className="page-wrapper">
            <div className="content">
                {/* Breadcrumb */}
                <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                    <div className="my-auto mb-2">
                        <h2 className="mb-1">Group Personal Accident</h2>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <Link to="/employee-dashboard">
                                        <i className="ti ti-smart-home" />
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Group Personal Accident
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                        <div className="head-icons ms-2">
                            <CollapseHeader />
                        </div>
                    </div>
                </div>
                {/* /Breadcrumb */}

                <div className="card p-4 shadow-sm">
                    <h4 className="mb-3">Key Information</h4>
                    <p><strong>DISCLAIMER NOTE:</strong> The information mentioned below is illustrative and not exhaustive. The information must be read in conjunction with the policy wordings. In case of any conflict between the Key Information Sheet and the policy wordings, the terms and conditions mentioned in the policy wordings shall prevail.</p>

                    <div className='table-responsive'>
                        <table className="table table-bordered mt-3">
                            <tbody>
                                <tr>
                                    <th style={{ width: '50px' }}>SNo</th>
                                    <th style={{ minWidth: '150px' }}>Title</th>
                                    <th style={{ minWidth: '350px', maxWidth: '600px', wordWrap: 'break-word', whiteSpace: 'normal' }}>Description</th>
                                </tr>
                                <tr><td>1</td><td><strong>Product Name</strong></td><td>Group Personal Accident</td></tr>
                                <tr>
                                    <td>2</td>
                                    <td><strong>What is covered under the policy?</strong></td>
                                    <td>The policy covers the Insured Person (or his Nominee/ legal heir, as the case may be) for the occurrence of any Insured Event, as specifically described, under different Benefit(s) (and Extensions ­ if any) arising due to an Injury sustained by the Insured Person during the Policy Period but not exceeding the Sum Insured as specified under the respective Benefits (and Extensions ­ if any) under Policy Schedule. The cover is for 24 hours or as mentioned in Part 1 of the policy and on a worldwide basis.</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td><strong>Coverage and Optional Add-ons</strong></td>
                                    <td>
                                        <strong>Benefits:</strong>
                                        <ul>
                                            <li>Death</li>
                                            <li>Permanent Total Disablement</li>
                                            <li>Permanent Partial Disablement</li>
                                            <li>Temporary Total Disablement</li>
                                        </ul>
                                        <strong>Extensions:</strong>
                                        <ul>
                                            <li>Burns Expenses</li>
                                            <li>Modification of Home & Vehicle</li>
                                            <li>Ambulance Charges</li>
                                            <li>Loss of Job Cover</li>
                                            <li>Daily Cash Allowance</li>
                                            <li>Accidental Hospitalization</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td><strong>What are the major Exclusions in the Policy</strong></td>
                                    <td>
                                        <ul>
                                            <li>Suicide, attempt to Suicide or intentionally self­ inflicted injury, sexually transmitted conditions, mental disorder, anxiety, stress or depression.</li>
                                            <li>Being under influence of drugs, alcohol, or other intoxication or hallucinogens</li>
                                            <li>Participation in actual or attempted felony, riot, civil commotion, crime misdemeanor</li>
                                            <li>Committing any breach of law of land with criminal intent.</li>
                                            <li>Death or disablement resulting from Pregnancy or childbirth.</li>
                                            <li>Professional sports team in respect of specific benefit for inability to perform</li>
                                            <li>Participation in any kind of motor speed contest.</li>
                                            <li>While engaged in aviation, or whilst mounting or dismounting from or traveling in any aircraft. ( Not applicable for fare Paying Passengers) Underground mining & contractor specializing in tunneling.</li>
                                            <li>Naval, military or air force personnel Radioactivity, Nuclear risks, ionizing radiation.</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td><strong>Payout Basis</strong></td>
                                    <td>Reimbursement claims of covered benefits upto specified sum insured as per the scope of cover.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <h4 className="mt-5">Key Information</h4>
                    <table className="table table-bordered mt-3">
                        <tbody>
                            <tr><td>1</td><td>B - Accidental Death + loss of limbs + loss of eyes + Permanent Total Disablement</td></tr>
                            <tr>
                                <td>2</td>
                                <td>C - Accidental Death + loss of limbs + loss of eyes + Permanent Total Disablement + Permanent Partial Disablement</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Subject to Medical Benefits Endorsement</td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>The policy is issued on named basis</td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>D1 (A) + (B) + (C) + Temporary Total Disablement (TTD) 1% of S I Or Rs 5000/- per week or actual salary whichever is less</td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>	Age Band 18-65 years</td>
                            </tr>
                            <tr>
                                <td>7</td>
                                <td>Medical expenses payable only if claim is admissible under Benefit Table Opted</td>
                            </tr>
                            <tr>
                                <td>8</td>
                                <td>Medical Expenses 40% of death/disability claim amount or 10% of S I or actual whichever is less triggered only when claim is admissible under benefit table A, B, C or D1</td>
                            </tr>
                            <tr>
                                <td>9</td>
                                <td>Risk Category I & II are covered</td>
                            </tr>
                            <tr>
                                <td>10</td>
                                <td>	Premium to be charged on prorata scale for addition/ deletion endorsement</td>
                            </tr>
                            <tr>
                                <td>11</td>
                                <td>Any endorsements will be from the date of addition and not from the inception of the policy</td>
                            </tr>
                            <tr>
                                <td>12</td>
                                <td>Premium shall not be refunded for deletion if any claim is paid during the policy</td>
                            </tr>
                            <tr>
                                <td>13</td>
                                <td>Terrorism is covered, however, terrorism activity arising out of Nuclear, Biological and/or Chemical means is excluded from the scope of this policy</td>
                            </tr>
                            <tr>
                                <td>14</td>
                                <td>A - Accidental Death only - 100%</td>
                            </tr>
                            <tr>
                                <td>15</td>
                                <td>	Children Education Welfare Fund for dependent children in case of Death of Employee - upto 10,000/- per child (Restricted to 2 children)</td>
                            </tr>
                            <tr>
                                <td>16</td>
                                <td>Carriage of Dead Body 2% of SI subject to max to Rs 2500/-</td>
                            </tr>

                        </tbody>
                    </table>
                    <h4 className="mt-4 mb-2">Special Conditions</h4>
                    <p>Below mentioned activity shall be outside the scope of the policy:-</p>
                    <ul>
                        <li>Professional sports team in respect of specific benefit for inability to perform..</li>
                        <li>Participation in any kind of motor speed contest.</li>
                        <li>While engaged in aviation, or whilst mounting or dismounting from or traveling in any aircraft. (Not applicable for fare Paying Passengers)</li>
                        <li>Underground mining & contractor specializing in tunneling</li>
                        <li>Naval, military or air force personnel.</li>
                        <li>Radioactivity, Nuclear risks, ionizing radiation.</li>
                        <li>Drivers are excluded from the policy.</li>
                        <li>Animal bite/Snake Bite/Insect bite is not covered.</li>
                        <li>Perils of the sea are excluded from the scope of the policy.</li>
                    </ul>

                    <h4 className="mt-4 mb-2">Exclusions:</h4>
                    <ul>
                        <li>Suicide, attempt to Suicide or intentionally self- inflicted injury, sexually transmitted conditions, mental disorder, anxiety, stress or depression.</li>
                        <li>Being under influence of drugs, alcohol, or other intoxication or hallucinogens.</li>
                        <li>Participation in actual or attempted felony, riot, civil commotion, crime misdemeanor</li>
                        <li>Committing any breach of law of land with criminal intent.</li>
                        <li>Death or disablement resulting from Pregnancy or childbirth.</li>
                        <li>Risk Category III people are out of the scope of the policy:-</li>
                        <ul>
                            <li>Persons working in mines,explosives,Electrical installations on high tension lines,Racing,Circus</li>
                            <li>People,skiing,mountaineering,big game hunting,ballooning,hang gliding,river rafting,winter sports, skiing,ice hockey,polo&such other persons engaged in occupation of similar hazard are not covered under GPA</li>
                        </ul>
                    </ul>
                    <h4 className="mt-4">Clauses:</h4>
                    <p>1. The Cover is subject to inclusion of loss/ damage/ liability due to terrorism activity.</p>
                    <h4 className="mt-1">Warranties</h4>
                    <p>The claim should be intimated with in the three months of the occurrence of the event, failing to which company shall not be liable to pay the claim.</p>
                </div>
            </div>
            <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
                <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>

            </div>
        </div>
    );
};

export default GroupPersonalAccident;
